import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API as API_BASE_URL } from "../apiConfig";

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const username = form.username.trim();
    const password = form.password.trim();

    if (!username || !password) {
      setError("Username आणि Password आवश्यक आहे.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await axios.post(
        `${API_BASE_URL}/login`,
        { username, password },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          timeout: 15000,
        }
      );

      if (!res.data?.success || !res.data?.token) {
        setError(res.data?.message || "Login failed");
        return;
      }

      sessionStorage.setItem("token", res.data.token);
      sessionStorage.setItem("user", JSON.stringify(res.data.user || {}));
      sessionStorage.setItem("permissions", JSON.stringify(res.data.permissions || {}));

      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || "Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="eb-login-page">
      <section className="eb-login-left">
        <div className="eb-login-card">
          <div className="eb-logo-wrap">
            <div className="eb-logo-icon">EB</div>
            <h1>E-Billing</h1>
            <p>Smart Billing & Inventory Management</p>
          </div>

          {error && <div className="eb-login-error">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="eb-field">
              <label>Username</label>
              <input
                name="username"
                type="text"
                value={form.username}
                onChange={handleChange}
                placeholder="Enter username"
                autoComplete="username"
                disabled={loading}
                autoFocus
              />
            </div>

            <div className="eb-field">
              <label>Password</label>
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            <button type="submit" className="eb-login-btn" disabled={loading}>
              {loading ? "Please wait..." : "Login"}
            </button>
          </form>

          <div className="eb-login-footer">Version 1.0 • MJ Corporation</div>
        </div>
      </section>

      <section className="eb-login-right">
        <div className="eb-hero">
          <h2>Smart Billing? No Problem.</h2>
          <p>GST / Non-GST billing, barcode stock, ledger and reports in one place</p>

          <div className="eb-visual">
            <div className="eb-chart-card">
              <div className="eb-chart-header">
                <div>
                  <span>Today Sales Flow</span>
                  <h3>₹ 48,250</h3>
                </div>
                <b>+18%</b>
              </div>

              <div className="eb-chart-area">
                <i style={{ height: "36%" }}></i>
                <i style={{ height: "62%" }}></i>
                <i style={{ height: "48%" }}></i>
                <i style={{ height: "78%" }}></i>
                <i style={{ height: "58%" }}></i>
                <i style={{ height: "92%" }}></i>
              </div>

              <div className="eb-chart-footer">
                <span>Mon</span>
                <span>Tue</span>
                <span>Wed</span>
                <span>Thu</span>
                <span>Fri</span>
                <span>Sat</span>
              </div>
            </div>

            <div className="eb-flow-card">
              <span>Purchase</span>
              <b></b>
              <span>Stock</span>
              <b></b>
              <span>Sale</span>
              <b></b>
              <span>Ledger</span>
            </div>

            <img
              src="/images/login-man.png"
              alt="Business user with tablet"
              className="eb-login-man"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />

            <div className="eb-man-fallback">
              <div className="eb-fallback-head"></div>
              <div className="eb-fallback-body"></div>
              <div className="eb-fallback-tab"></div>
            </div>

            <div className="eb-mail-badge">Barcode • GST • Stock • Ledger</div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Login;